import {
  Button,
  Grid,
  Hidden,
  Switch,
  Typography,
  useTheme
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import moment from "moment";
import "moment/locale/de";
import { useCallback, useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import DefaultDateHeader from "react-big-calendar/lib/DateHeader";
import "react-big-calendar/lib/sass/styles.scss";
import { useTranslation } from "react-i18next";
import { pad } from "../../functions/default";
import "./Kalender.css";

function Kalender({
  events,
  year,
  month,
  jahresAnsicht=false,
  onMonthChange,
  onYearChange,
  onJahresAnsichtChange,
}) {
  const { t } = useTranslation();
  moment.locale("de");

  const localizer = momentLocalizer(moment);
  const [open, setOpen] = useState(false);
  const [eventStart, setEventStart] = useState("");
  const [eventEnde, setEventEnde] = useState("");
  const theme = useTheme();
  const [eventTitle, setEventTitle] = useState("");
  const [eventInfo, setEventInfo] = useState("");
  let newDate = new Date();
  const [currentDate, setCurrentDate] = useState(new Date(year, month));

  useEffect(() => {
    setCurrentDate(new Date(year, month));
  }, [year, month])
  

  const handleJahresAnsichtChange = (value) => {
    if (typeof onJahresAnsichtChange === 'function') {
      onJahresAnsichtChange(value);
    }
  }

  const handleYearChange = (newYear) => {
    if (typeof onYearChange === 'function' && year !== newYear) {
      onYearChange(newYear);
    }
  }

  const MonatAuswahl = (monat) => {
    onMonthChange(monat);
    handleJahresAnsichtChange(false);
  };
  const handleClickOpen = (event) => {
    let startmonat = event.start.substr(5, 2);
    let endeMonat = event.end.substr(5, 2);
    setEventStart(
      event.start.substr(8, 2) +
        "." +
        startmonat +
        "." +
        event.start.substr(0, 4)
    );
    setEventEnde(
      event.end.substr(8, 2) + "." + endeMonat + "." + event.end.substr(0, 4)
    );
    setEventInfo(event.antrag === "J" ? "Antrag" : "Abwesenheit");
    setEventTitle(event.bez);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const weekNumber = {
    textAlign: "left",
    align: "left",
    color: "grey",
    fontWeight: "bold",
    position: "absolute",
    top: "0px",
    left: "5px",
  };
  const weekNumber2 = {
    textAlign: "left",
    align: "left",
    color: "grey",
    fontWeight: "bold",
    position: "absolute",
    top: "0px",
    left: "5px",
  };

  const WeekNumber = ({ week, weekYear }) => (
    <span style={weekNumber} title={`Week ${week}-${weekYear}`}>
      ({week})
    </span>
  );
  const WeekNumber2 = ({ week, weekYear }) => (
    <span style={weekNumber2} title={`Week ${week}-${weekYear}`}>
      ({week})
    </span>
  );
  function DateHeader2(dateEvent, tmpmonat) {
    const { t } = useTranslation();
    const m = moment(dateEvent.date);
    const monakt = year + pad(tmpmonat + 1, 2).toString();
    return (
      <>
        {
          // Display week number on leftmost day in calendar view
          m.weekday() === 0 && (
            <Hidden xlDown>
              <WeekNumber2 week={m.week()} weekYear={m.weekYear()} />
            </Hidden>
          )
        }
        {monakt === m.format("YYYYMM") && <DefaultDateHeader {...dateEvent} />}
      </>
    );
  }

  const DateHeader = (dateEvent) => {
    const m = moment(dateEvent.date);
    const monakt = year + pad(month + 1, 2).toString();
    return (
      <>
        {
          // Display week number on leftmost day in calendar view
          m.weekday() === 0 && (
            <Hidden smDown>
              <WeekNumber week={m.week()} weekYear={m.weekYear()} />
            </Hidden>
          )
        }
        {monakt === m.format("YYYYMM") && <DefaultDateHeader {...dateEvent} />}
      </>
    );
  };
  const changeYear = (wert, current) => {
    let newYear = (parseInt(current, 10) + wert).toString();
    handleYearChange(newYear);
  };
  const MonatsKalender = (monat) => {
    return (
      <Calendar
        toolbar={false}
        localizer={localizer}
        dayPropGetter={(day, string) => {
          let bgcolor = () => {
            let bgcolor = "";
            if (
              year + "-" + monat + "-" + day.getDate() ===
              newDate.getFullYear() +
                "-" +
                newDate.getMonth() +
                "-" +
                newDate.getDate()
            ) {
              bgcolor = theme.palette.background.highlight;
            }
            if (day.getDay() === 0) {
              bgcolor = theme.palette.background.dim;
            }
            if (day.getDay() === 6) {
              bgcolor = theme.palette.background.dim;
            }
            if (day.getMonth() !== monat) {
              bgcolor = theme.palette.background.dim2;
            }
            return bgcolor;
          };
          let newStyle = {
            backgroundColor: bgcolor(),
          };
          return {
            className: "",
            style: newStyle,
          };
        }}
        eventPropGetter={(event, start, end, isSelected) => {
          let bgcolor = () => {
            if (event.antrag === "J") {
              return `repeating-linear-gradient(-53deg, #00000000, #00000000 5px, rgba(${event.red},${event.green},${event.blue},0.5) 5px, rgba(${event.red},${event.green},${event.blue},0.5) 10px`;
            }
            return `rgba(${event.red},${event.green},${event.blue},0.7)`;
          };
          let bdcolor = () => {
            return `rgba(${event.red},${event.green},${event.blue},1)`;
          };
          let ftcolor = () => {
            if (event.antrag === "J") {
              return `inherit`;
            }
            return `rgba(${"000"},${"000"},${"000"},1)`;
          };
          let newStyle = {
            color: ftcolor(),
            border: "2px solid " + bdcolor(),
            // backgroundColor: bgcolor(),
            background: bgcolor(),
          };
          return {
            className: "",
            style: newStyle,
            start: new Date(parseInt(start)),
            end: new Date(parseInt(end)),
          };
        }}
        events={CutEvents(year, monat + 1)}
        views={["month"]}
        step={60}
        date={new Date(year, monat)}
        startAccessor="start"
        endAccessor="end"
        selectable
        onSelectEvent={(event) => handleClickOpen(event)}
        components={{
          dateHeader: (props) => DateHeader2(props, monat),
        }}
        style={{ height: 350, border: "1px solid " + theme.palette.borderColor }}
      />
    );
  };
  const CutEvents = useCallback(
    (j, m) => {
      const evs = events?.map((item) => ({ ...item }));
      var u_j = j;
      var u_m = m;
      var jahrs = u_j.toString();
      var mons = pad(u_m.toString(), 2);
      var mstart = jahrs + mons + "01";
      var mend = new Date(u_j, u_m, 0);
      mend =
        mend.getFullYear().toString() +
        pad(mend.getMonth() + 1, 2) +
        pad(mend.getDate(), 2);
      var tmpliste = [];
      evs.forEach((obj, index) => {
        var item = Object.assign(obj);
        if (item.start.replace(/-/g, "").substr(0, 6) > jahrs + mons) return;
        if (item.end.replace(/-/g, "").substr(0, 6) < jahrs + mons) return;
        var ts =
          mstart > item.start.replace(/-/g, "")
            ? mstart
            : item.start.replace(/-/g, "");
        item.start =
          ts.substr(0, 4) + "-" + ts.substr(4, 2) + "-" + ts.substr(6, 2);
        var te =
          mend < item.end.replace(/-/g, "") ? mend : item.end.replace(/-/g, "");
        item.end =
          te.substr(0, 4) + "-" + te.substr(4, 2) + "-" + te.substr(6, 2);
        item.end += " 23:59";
        tmpliste.push(item);
      });
      return tmpliste;
    },
    [events]
  );

  return (
    <div>
      <Typography>{t("Monatsansicht      -       Jahresansicht")}</Typography>
      <Switch
        checked={jahresAnsicht}
        onChange={(event) => handleJahresAnsichtChange(event.target.checked)}
        name="checkedA"
        inputProps={{ "aria-label": "secondary checkbox" }}
      />
      {jahresAnsicht === true && (
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(0)}
            >
              {t("Januar")}
            </Button>
            {MonatsKalender(0)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(1)}
            >
              {t("Februar")}
            </Button>
            {MonatsKalender(1)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(2)}
            >
              {t("März")}
            </Button>
            {MonatsKalender(2)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(3)}
            >
              {t("April")}
            </Button>
            {MonatsKalender(3)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(4)}
            >
              {t("Mai")}
            </Button>
            {MonatsKalender(4)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(5)}
            >
              {t("Juni")}
            </Button>
            {MonatsKalender(5)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(6)}
            >
              {t("Juli")}
            </Button>
            {MonatsKalender(6)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(7)}
            >
              {t("August")}
            </Button>
            {MonatsKalender(7)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(8)}
            >
              {t("September")}
            </Button>
            {MonatsKalender(8)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(9)}
            >
              {t("Oktober")}
            </Button>
            {MonatsKalender(9)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(10)}
            >
              {t("November")}
            </Button>
            {MonatsKalender(10)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button
              style={{ textTransform: "none" }}
              onClick={(event) => MonatAuswahl(11)}
            >
              {t("Dezember")}
            </Button>
            {MonatsKalender(11)}
          </Grid>
          <Grid item xs={12} sm={6} lg={4}></Grid>
        </Grid>
      )}

      {jahresAnsicht === false && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Calendar
        toolbar={false}
        localizer={localizer}
              dayPropGetter={(day, string) => {
                let bgcolor = () => {
                  let bgcolor = "";
                  if (
                    year + "-" + month + "-" + day.getDate() ===
                    newDate.getFullYear() +
                      "-" +
                      newDate.getMonth() +
                      "-" +
                      newDate.getDate()
                  ) {
                    bgcolor = theme.palette.background.highlight;
                  }
                  if (day.getDay() === 0) {
                    bgcolor = theme.palette.background.dim;
                  }
                  if (day.getDay() === 6) {
                    bgcolor = theme.palette.background.dim;
                  }
                  if (day.getMonth() !== month) {
                    bgcolor = theme.palette.background.dim2;
                  }
                  return bgcolor;
                };
                let newStyle = {
                  backgroundColor: bgcolor(),
                };
                return {
                  className: "",
                  style: newStyle,
                };
              }}
              eventPropGetter={(event, start, end, isSelected) => {
                let bgcolor = () => {
                  if (event.antrag === "J") {
                    return `repeating-linear-gradient(-53deg, #00000000, #00000000 5px, rgba(${event.red},${event.green},${event.blue},0.5) 5px, rgba(${event.red},${event.green},${event.blue},0.5) 10px`;
                  }
                  return `rgba(${event.red},${event.green},${event.blue},0.7)`;
                };
                let bdcolor = () => {
                  return `rgba(${event.red},${event.green},${event.blue},1)`;
                };
                let ftcolor = () => {
                  if (event.antrag === "J") {
                    return `inherit`;
                  }
                  return `rgba(${"000"},${"000"},${"000"},1)`;
                };
                let newStyle = {
                  color: ftcolor(),
                  border: "2px solid " + bdcolor(),
                  background: bgcolor(),
                };
                return {
                  className: "",
                  style: newStyle,
                  start: new Date(parseInt(start)),
                  end: new Date(parseInt(end)),
                };
              }}
              messages={{
                next: ">",
                previous: "<",
                today: "Heute",
                month: "Monat",
              }}
              events={CutEvents(year, month + 1)}
              views={["month"]}
              step={60}
              date={currentDate}

              startAccessor="start"
              components={{
                dateHeader: DateHeader,
              }}
              endAccessor="end"
              selectable
              onSelectEvent={(event) => handleClickOpen(event)}
              style={{ height: 600 }}
            />
          </Grid>
        </Grid>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{t("Informationen ")}</DialogTitle>
        <DialogContent>
          <Typography>Art: {eventTitle}</Typography>
          <Typography>Typ: {eventInfo}</Typography>
          <Typography>Start: {eventStart}</Typography>
          <Typography>Ende: {eventEnde}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("OK")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export { Kalender };

